<template>
  <su-page>
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
      <div class="flex ju-sp">
        <el-form-item>
          <el-button type="primary" size="mini" @click="handleAdd">新增内容</el-button>
        </el-form-item>
        <div>
          <el-form-item>
            <div class="flex">
              <el-input
                  v-model="queryParams.keyword"
                  placeholder="输入ID或昵称"
                  clearable
                  @keyup.enter.native="handleQuery"
              />
              <div class="searchBut pointer" @click="handleQuery">
                搜索 <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="platform_id">
            <el-select
                style="width: 130px"
                clearable
                v-model="queryParams.platform_id"
                placeholder="全部平台"
                @change="handleQuery">
              <el-option
                  v-for="item in platformList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="dice_id">
            <el-select
                style="width: 130px"
                clearable
                v-model="queryParams.dice_id"
                placeholder="全部框架"
                @change="handleQuery">
              <el-option
                  v-for="item in diceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="mode">
            <el-select
                style="width: 130px"
                clearable
                v-model="queryParams.mode"
                placeholder="全部模式"
                @change="handleQuery"
            >
              <el-option
                  v-for="item in modeList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </div>
      <!--      <el-form-item>
              <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>-->
    </el-form>
    <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{backgroundColor:'#F3F4F8'}"
        border
        ref="singleTable"
        highlight-current-row
        style="width: 100%">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column label="对接中心" prop="platform_text"/>
      <el-table-column label="昵称" prop="third_name"/>
      <el-table-column label="状态" prop="status_text"/>
      <el-table-column label="简介" prop="intro" show-overflow-tooltip/>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-edit"
              @click="handleUpdate(scope.row)">
            编辑
          </el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handleDetails(scope.row)">
            详情
          </el-button>
          <el-button
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex ju-cn">
      <pagination
          v-show="total > 0"
          :total="total"
          layout="prev, pager, next"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.limit"
          @pagination="getMyLists"
      />
    </div>
    <my-dialog
        v-if="open"
        :title="title"
        :form="form"
        :modeList="modeList"
        :blackList="blackList"
        :platformList="platformList"
        :diceList="diceList"
        :statusList="statusList"
        @refresh="handleQuery"
        @cancel="open = false"/>
    <el-dialog title="用户内容发布规范与法律责任协议" :visible.sync="dialogVisible" width="60%">
      <div v-html="setting.publish_doc"></div>
    </el-dialog>
  </su-page>
</template>

<script>
import Pagination from "@/components/Pagination/index.vue";
import myDialog from "@/components/my-dialog/my-dialog.vue";
import {botDel, botDetail, getItem, getMyLists} from "@/api/api";
import {mapState} from "vuex";

export default {
  name: "index",
  components: {Pagination, myDialog},
  data() {
    return {
      // 表格数据
      list: [],
      // 总条数
      total: 2,
      // 弹出层标题
      title: "新增",
      // 是否显示弹出层
      open: false,
      loading: false,

      queryParams: {
        page: 1,
        limit: 10,
        keyword: '',
        platform_id: '',
        dice_id: '',
        mode: '',
        status: '',
      },
      // 表单参数
      form: {},
      modeList: [], // 全部模式
      statusList: [], // 状态
      blackList: [], // 黑名单
      platformList: [], // 对接平台
      diceList: [], // 全部框架
      dialogVisible: false,
    }
  },
  computed: {
    ...mapState(['token', 'userInfo', 'setting']),
  },
  mounted() {
    this.getMyLists()
    this.getItem()
  },
  methods: {
    getItem() {
      getItem().then(res => {
        if (res.code === 1) {
          this.platformList = res.data.platform // 对接平台
          this.diceList = res.data.dice  // 全部框架
          this.modeList = res.data.mode // 全部模式
          this.statusList = res.data.status  // 状态
          this.blackList = res.data.blacklist // 黑名单
        }
      })
    },
    handleAdd() {
      this.open = true;
      this.title = "新增";
      this.form = {}
    },
    handleDetails(row) {
      this.open = true;
      this.title = "详情";
      this.botDetail(row)
    },
    handleUpdate(row) {
      this.open = true;
      this.title = "修改";
      this.botDetail(row)
    },
    handleDelete(row) {
      const vm = this;
      this.$confirm('是否确认删除账号为"' + row.third_name + '"的数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        botDel({
          id: row.id
        }).then(res => {
          if (res.code === 1) {
            vm.getMyLists();
            vm.$message({message: "删除成功", type: "success"});
          }
        })
      }).catch(function () {
      });
    },
    /** 详情 */
    botDetail(row) {
      botDetail({
        id: row.id
      }).then(res => {
        if (res.code === 1) {
          this.form = res.data
        }
      })
    },
    // 重置按钮操作
    resetQuery() {
      this.$refs.queryForm.resetFields(); //重置表单
      this.handleQuery();
    },
    // 搜索按钮操作
    handleQuery() {
      this.queryParams.page = 1;
      this.getMyLists();
    },
    /** 搜索按钮操作 */
    getMyLists() {
      if (this.loading) return
      this.loading = true;
      getMyLists(this.queryParams).then(response => {
        if (response.code === 1) {
          this.list = response.data.data;
          this.total = response.data.total;
        }
        this.loading = false;
      }).catch(error => {
        this.loading = false;
        console.log(error)
      });
    },
  }
}
</script>

<style scoped lang="scss">

</style>
